import React from 'react';
import './App.css';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Provider }from 'react-redux';
import store from "./store";
import Home from "./Home.js";
import Report from "./views/Report.js";
import Login from "./views/Login.js";
import Test from "./views/Test.js";
import OnlineLogin from "./views/online/Index";
import AcademicReport from "./views/online/Home";
import AcademicReportDetails from "./views/online/ReportDetails";
import AcademicAnalysis from "./views/online/Analysis";



const App = () => (
  <Provider store={ store }>
    <div  className="App">
    <BrowserRouter basename='/students' >
      <Routes>
        <Route path="/" element={<Login/>}></Route>
        <Route path="/test/:id" element={<Test/>}></Route>
        <Route path="/online/:schoolid/:reportid/:studentid" exact element={<OnlineLogin/>}/>
        <Route path="/online/:schoolid/:reportid/:studentid/report" exact  element={<AcademicReport/>} />
        <Route path="/online/:schoolid/:reportid/:studentid/reportdetails" exact  element={<AcademicReportDetails/>} />
        <Route path="/online/:schoolid/:reportid/:studentid/analysis" exact  element={<AcademicAnalysis/>} />
        <Route path="/home" element={<Home />}>
          <Route path="/home/:index" element={<Home />} >
            <Route path="/home/:index/:index1" element={<Home />} >
              <Route path="/home/:index/:index1/:index2" element={<Home />} >
                <Route path="/home/:index/:index1/:index2/:index3" element={<Home />} />
                </Route>
            </Route>
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
    </div>
  </Provider>
);

export default App;
